import React, { useState } from 'react';
import { Input } from 'components/form/input';
import { SelectCurrency } from 'components/form/compobox/select-priceand-unit';
import CheckboxCustom from 'components/form/checkboxone';
import { FieldArray, useFormikContext } from 'formik'

/**
 * Fiyat/Döviz bölümü HER ZAMAN 4 satır render eder.
 *
 * UNDERLYING MIX SLOT SEMANTİĞİ (asla değişmez):
 *   mix[0] = EUR/AUD  (SelectCurrency name="currency1")
 *   mix[1] = EUR/CLP  (SelectCurrency name="currency2")
 *   mix[2] = USD/BRL  (SelectCurrency name="currency3")
 *   mix[3] = GBP      (SelectCurrency name="currency4")
 *
 * NORMAL ZARA + newPriceLabel (schemaVersion >= 1) modunda SADECE GÖRSEL SIRA değişir:
 *   Visible row 1 → mix[2] (USD 69.90)
 *   Visible row 2 → mix[3] (GBP 39.99)
 *   Visible row 3 → mix[0] (boş — PRICE_BLACK legacy mix'e asla yazılmaz)
 *   Visible row 4 → mix[1] (boş)
 * Input name / Formik path ve SelectCurrency options her zaman GERÇEK slot indexine
 * bağlıdır — sadece display reorder yapılır, data mapping kaymaz.
 *
 * Legacy/manual Zara (newPriceLabel yok): sıra [0, 1, 2, 3] aynen korunur.
 * ZaraHome etkilenmez.
 */

// mix slot index → SelectCurrency name (options setini bu belirler)
const SLOT_TO_CURRENCY_NAME = {
  0: 'currency1', // EUR/AUD
  1: 'currency2', // EUR/CLP
  2: 'currency3', // USD/BRL
  3: 'currency4'  // GBP
}

export default function PriceSection({idx}) {
  // Her bir fiyat girişi için ayrı state'ler
  const { values, setFieldValue } = useFormikContext()

  const isNewZaraPriceLabel =
    values?.newPriceLabel?.schemaVersion >= 1 &&
    values?.newPriceLabel?.brand === 'ZARA';

  // Yeni Zara: USD/GBP üstte, boş EUR slotları altta. Legacy: mevcut sıra.
  const visibleOrder = isNewZaraPriceLabel ? [2, 3, 0, 1] : [0, 1, 2, 3]

  const [currency1, setCurrency1] = useState('');
  const [price1, setPrice1] = useState('');
  const [currency2, setCurrency2] = useState('');
  const [price2, setPrice2] = useState('');
  const [currency3, setCurrency3] = useState('');
  const [price3, setPrice3] = useState('');
  const [currency4, setCurrency4] = useState('');
  const [price4, setPrice4] = useState('');

  // Her bir input için ayrı handleChange fonksiyonları
  const handleChangeCurrency1  = (event) => setCurrency1(event.target.value);
  const handleChangePrice1 = (event) => setPrice1(event.target.value);
  const handleChangeCurrency2  = (event) => setCurrency2(event.target.value);
  const handleChangePrice2 = (event) => setPrice2(event.target.value);
  const handleChangeCurrency3  = (event) => setCurrency3(event.target.value);
  const handleChangePrice3 = (event) => setPrice3(event.target.value);
  const handleChangeCurrency4  = (event) => setCurrency4(event.target.value);
  const handleChangePrice4 = (event) => setPrice4(event.target.value);

  // Her visible row kendi GERÇEK mix slotuna bağlanır
  const renderRow = (mixIndex) => (
    <div
      className="mb-2 grid grid-cols-2 gap-x-2 text-sm font-medium text-simsek"
      key={`mix-${mixIndex}`}
    >
      <Input
        name={`priceLabel[${idx}].mix[${mixIndex}].currency`}
        autoComplete="off"
        value={values.priceLabel[idx].mix[mixIndex]?.currency}
        onChange={(e) => {
          const value = e.target.value;
          // Nokta veya virgül ile ondalık ayırıcıyı kabul et
          const normalizedValue = value.replace(/,/g, '.'); // Tüm virgülleri noktaya çevir
          if (/^\d*\.?\d*$/.test(normalizedValue) || value === '') {
            // Doğrudan normalizedValue'yi kullanarak backend'e gönderilecek veriyi dönüştürün
            setFieldValue(`priceLabel[${idx}].mix[${mixIndex}].currency`, normalizedValue);
          }
        }}
      />
      <SelectCurrency name={SLOT_TO_CURRENCY_NAME[mixIndex]} idx={idx} />
    </div>
  )

  return (
    <div className="space-y-2 border border-dashed p-2 rounded">
      <div className="mb-2 grid grid-cols-2 gap-x-5 text-sm font-medium text-simsek">
        <p>Fiyat</p>
        <p>Döviz</p>
      </div>

      {visibleOrder.map((mixIndex) => renderRow(mixIndex))}

      <CheckboxCustom label="Siparişte RFID 'li etiket var mı ?" name="termsAccepted" idx={idx} />
    </div>
  );
}
